// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__19l7Z","log":"ModalInventoryLogs_log__1x3fw","date":"ModalInventoryLogs_date__3qT15","userName":"ModalInventoryLogs_userName__3BxPd"};